// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import React from "react";

const WarrantyClaimsFormPage = ({ id }: PageProps) => {
    return (
        <Page>
            <Zone contentId={id} zoneName="Content"></Zone>
        </Page>
    );
};

const pageModule: PageModule = {
    component: WarrantyClaimsFormPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "System",
    },
};

export default pageModule;
